export default "__VITE_ASSET__Gs4dcXgL__"